import { useEffect, useState } from 'react';

// Matches the auto-collapse breakpoint already used by DocumentProperties.module.css.
const NARROW_VIEWPORT_QUERY = '(max-width: 1279px)';

const supportsMatchMedia = (): boolean =>
  globalThis.window !== undefined &&
  typeof globalThis.window.matchMedia === 'function';

export function useIsNarrowEditorViewport(): boolean {
  const [isNarrow, setIsNarrow] = useState(() =>
    supportsMatchMedia()
      ? globalThis.window.matchMedia(NARROW_VIEWPORT_QUERY).matches
      : false,
  );

  useEffect(() => {
    if (!supportsMatchMedia()) {
      return;
    }
    const mediaQuery = globalThis.window.matchMedia(NARROW_VIEWPORT_QUERY);
    const handler = (event: MediaQueryListEvent) => setIsNarrow(event.matches);
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  return isNarrow;
}
